import {
  Component, OnDestroy, OnInit, OnChanges, SimpleChanges,
  ElementRef, ViewChild, AfterViewInit, NgZone, Optional, Input, Output
} from '@angular/core';
import { Observable, combineLatest, of, Subscription, from } from 'rxjs';
import { catchError, map, mergeMap } from "rxjs/operators";
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from "@angular/forms";
import {
  DwConfigServiceToken, DwConfigService, DwSecurityUserService, DwComponent, DwComponentType, DwMetaDataService,
  DwSectionBaseComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfig,
  DwMetaDataFormApi, DwActionPreference, DwFormActionConfig, DwFormActionKeys,
  DwFormActionInterceptResult, DwFormValidationResult, DwEventService, DwOrmDataService,
  DwUIMetaDataConfigToken, DwMetaDataServiceToken, DwFormActionInterceptor
}
  from '@devwareapps/devware-cap';
import { DwMetaDataFormStateService } from '@devwareapps/devware-cap';
import { AviatorUser } from '../../../shared/models/aviator-user.model';
import { Inject, Injectable } from "@angular/core";
import { AppMetaDataItemNames, ProcessorConfigEntity, PaymentMethodEntity, UserTypeAllItems }
  from '../../../../meta-data/app-meta-data.service';
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { HttpClient } from "@angular/common/http";
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { environment } from 'src/environments/environment';
import { EnvironmentConfigItem } from 'src/environments/models/environment-config.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { AdminManagerService } from 'src/app/features/admin/services/admin-manager.service';
import { BillingDetailsContext } from '../../models/billings-details.model';
import { AviatorOnlineUserTypeIds } from 'src/app/features/shared/models/aviator-user-type.enum';
import { PaymentParty } from '../../models/payment-party.enum';
import { StripeDiagnosticsService } from '../../services/stripe-diagnostics.service';

@DwComponent({
  key: 'payments-add-payment',
  name: 'Payments (Add Payment)',
  componentType: DwComponentType.formSection,
  isGlobal: true,
})
@Component({
  selector: 'app-payments-add-payment',
  templateUrl: './payments-add-payment.component.html',
  styleUrls: ['./payments-add-payment.component.scss']
})
export class PaymentsAddPaymentComponent extends DwSectionBaseComponent
  implements OnInit, OnDestroy {
  constructor(
    private ngZone: NgZone,
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Optional() private dwFormStateService: DwMetaDataFormStateService,
    private dwSecurityUserService: DwSecurityUserService,
    private paymentsRepoSvc: PaymentsRepositoryService,
    private dateTimeUtilService: DateTimeUtilService,
    private dwEventService: DwEventService,
    private adminManagerService: AdminManagerService,
    private http: HttpClient,
    private stripeDiagnosticsService: StripeDiagnosticsService,
    @Inject(DwConfigServiceToken) private configService: DwConfigService) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
    this.formApi = this.dwFormStateService?.state.formApi;
  }

  usage: string = ModeNames.SchoolAddPayment;
  forSchool: boolean = true;
  forUser: boolean = false;
  adding: boolean = false;
  subscriptions: Subscription[] = [];
  aviatorUser: AviatorUser;
  paymentsApi: string;
  formApi: DwMetaDataFormApi;
  stripe: any;
  model: any = { customerId: undefined, billing: { name: undefined, email: undefined } }
  isFSAdmin: boolean = false;
  test: boolean = false;
  paymentReady: boolean = false;
  payment: any;
  elements: any;
  alreadyDefault: boolean;
  processorConfig: ProcessorConfigEntity = undefined;
  loading: boolean = true;
  stripeErrorMessage: string = undefined;
  error: any;
  setupIntent: any;
  target: AviatorOnlineUserTypeIds;

  setupComponentComplete() {
    this.setupFormActionInterceptor();
    this.dwFormStateService.addActionInterceptor(this.formActionInterceptor);
    this.formApi.getFormDataChanges(200)
      .subscribe((pm) => {
        const email = (pm.BillingEmail ?? '').length == 0 ? undefined : pm.BillingEmail;
        const name = (pm.BillingName ?? '').length == 0 ? undefined : pm.BillingName;
        const hasBlanks = email == undefined || name == undefined;
        if (email != undefined && name != undefined)
          return;

        this.formApi.patchFormData({
          BillingEmail: email ?? this.aviatorUser.user.Email,
          BillingName: name ?? `${this.aviatorUser.user.FirstName} ${this.aviatorUser.user.LastName}`
        });
      });
  }

  ngAfterViewInit() { this.setupPaymentElement(); }
  ngOnInit() {
    const cfgKey = this.dwFormStateService.state.formConfig.configKey;
    this.forSchool = cfgKey == ModeNames.SchoolAddPayment;
    this.target = this.forSchool ? AviatorOnlineUserTypeIds.flightSchool : AviatorOnlineUserTypeIds.student;
    this.forUser = cfgKey == ModeNames.StudentAddPayment;

    const paymentParty = this.forUser ? PaymentParty.Student : PaymentParty.FlightSchool;
    this.test = this.isTest();
    this.stripe = (globalThis as any).stripe;
    this.aviatorUser = this.adminManagerService.getAviatorUser();
    this.isFSAdmin = this.aviatorUser?.user.Permissions.indexOf(AppPermissions.flightSchoolAdmin) > -1;

    if (this.forSchool && !this.isFSAdmin)
      return; //close modal?

    this.paymentsRepoSvc.getProcessorConfig(paymentParty)
      .subscribe(result => {
        this.processorConfig = result.ProcessorConfig
        this.model.customerId = result.ProcessorConfig?.CustomerId;
      });
  }

  formActionInterceptor: DwFormActionInterceptor
  setupFormActionInterceptor() {
    const interceptor: DwFormActionInterceptor = {
      interceptorName: 'add-card-interceptor',
      onBeforeAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any) =>
        this.onBeforeAction(this, actionPref, actionConfig),
      onAfterAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any) =>
        this.onAfterAction(this, actionPref, actionConfig)
    }
    this.formActionInterceptor = interceptor;
  }
  onAfterAction(that: PaymentsAddPaymentComponent, actionPref: DwActionPreference<DwFormActionConfig>,
    actionConfig: any) {
    const result: DwFormActionInterceptResult = { abort: false }
    return this.postSubmit().pipe(mergeMap(pm => {
      return of(result);
    }));
  }
  onBeforeAction(that: PaymentsAddPaymentComponent, actionPref: DwActionPreference<DwFormActionConfig>,
    actionConfig: any) {
    const ready = that.paymentReady == true;
    const valid = that.isFormValid(that.formApi);
    const target = this.forSchool ? 'school' : 'student';
    const result: DwFormActionInterceptResult = {
      abort: !ready && valid,
      message: !valid ? undefined :
        !ready ? 'All payment details must be completed before adding'
          : `Adding verified card to ${target}`
    };
    this.adding = true;
    this.setupIntent = null;
    if (ready && valid)
      return this.submit().pipe(map(r => {
        const err = (r as any).error;
        result.abort = err != undefined || this.setupIntent == undefined;
        result.message = result.abort
          ? "Payment method failed verification."
          : "Payment method verified";
        if (!result.abort) {
          const pm = this.formApi.getFormData<PaymentMethodEntity>();
          let updates = {
            ProcessorConfigId: this.processorConfig.ProcessorConfigId,
            PaymentId: this.setupIntent.payment_method,
            ClientSecret: this.setupIntent.client_secret,
            SetupIntentId: this.setupIntent.id,
            DisplayName: (r as any).description
          };
          this.formApi.patchFormData(updates);
        }
        else
          this.adding = false;
        return result;
      }));
    else {
      this.adding = false;
      return of(result);
    }
  }

  isFormValid(formApi: DwMetaDataFormApi): boolean {
    let result = formApi?.validateForm().isValid ?? false;
    return result;
  }
  onChange(event) {
    const pm = this.formApi.getFormData<PaymentMethodEntity>();
  }

  createPaymentIntent(): Observable<ICreatePaymentIntent> {
    const url = `${this.paymentsApi}/setup-future-payment/${this.target}`;
    return this.http.get<ICreatePaymentIntent>(url);
  }

  setupPaymentElement() {
    this.createPaymentIntent()
      .subscribe({
        next: async r => {
          try {
            const clientSecret = r.ClientSecret;
            await this.setUpPaymentElement(clientSecret);
          } catch (error) {
            this.handleStripeError('Stripe payment element initialization failed for add payment', error);
          }
        },
        error: error => this.handleStripeError('Stripe setup intent creation failed for add payment', error)
      });
  }
  async setUpPaymentElement(clientSecret: string) {
    if (!this.stripe?.core || typeof this.stripe.core.elements != 'function') {
      this.handleStripeError('Stripe.js was unavailable during add payment setup', new Error('Stripe.js not loaded'));
      return;
    }

    const appearance = { theme: 'stripe' };
    const defaultValues = {
      billingDetails: {
        name: `${this.aviatorUser.user.FirstName} ${this.aviatorUser.user.LastName}`,
        email: this.aviatorUser.user.Email
      }
    };
    const fields = {
      billingDetails: {
        name: 'auto',
        email: 'auto',
        phone: 'auto',
        address: 'if_required'
      }
    };

    const options = {
      /*layout: 'accordion', */ appearance,
      defaultValues,
      fields
    };

    try {
      this.elements = this.stripe.core.elements({ clientSecret });
      this.payment = this.elements.create('payment', options);
      this.payment.mount('#payment-element');

      const wrapper = (e) => this.ngZone.run(() => this.paymentOnChange(this.formApi, e));
      this.payment.on('change', wrapper);
      this.loading = false;
      this.stripeErrorMessage = undefined;
    } catch (error) {
      this.handleStripeError('Stripe payment element mount failed for add payment', error);
    }
  }
  paymentOnChange(formApi: DwMetaDataFormApi, event: any) {
    if (formApi != undefined) {
      formApi.patchVariableContext<BillingDetailsContext>({
        Verified: event.complete
      });
      this.paymentReady = event.complete;
    }
  }

  submit(): Observable<any> {
    const paymentMethod = this.formApi.getFormData<PaymentMethodEntity>();

    const details = {
      elements: this.elements,
      redirect: 'if_required',
      confirmParams: { /* return_url: returnUrl */
        payment_method_data: {
          billing_details: {
            address: { postal_code: paymentMethod.BillingPostalCode }
          }
        },
      }
    };

    //const returnUrl = 'http://localhost:4201/admin/lab/payments/processor-config';
    return from(this.stripe.core.confirmSetup(details))
      .pipe(mergeMap(r => {
        this.error = (r as any).error;
        this.setupIntent = (r as any).setupIntent;

        let resp: any = { error: this.error, description: undefined };
        if (resp.error != undefined)
          return of(resp);

        const url = `${this.paymentsApi}/retrieve-card-details/${this.setupIntent.payment_method}`;
        return this.http.get(url)
          .pipe(mergeMap(r => {
            resp.description = (r as any).Description
            return of(resp);
          }));
      }),
      catchError(err => {
        this.handleStripeError('Stripe confirmSetup threw while adding a payment method', err, false);
        return of({ error: err });
      })
    );
  };
  postSubmit(): Observable<PaymentMethodEntity> {
    const pm = this.formApi.getFormData<PaymentMethodEntity>();
    const url = `${this.paymentsApi}/update-payment-method/${pm.PaymentId}/${this.target}`;
    return this.http.get(url)
      .pipe(map(resp => {
        const roPm = (resp as any).Ro;

        const evt = this.forSchool
          ? AddPaymentEvents.AddSchoolPayment
          : AddPaymentEvents.AddStudentPayment;
        this.dwEventService.publishEvent(evt, roPm);
        this.adding = false;
        return pm;
      }));
  };

  private handleStripeError(context: string, error: any, updateMessage: boolean = true) {
    this.loading = false;
    this.adding = false;

    if (updateMessage) {
      this.stripeErrorMessage = 'We could not load the secure payment form. Please refresh and try again. If the issue continues, contact support.';
    }

    this.stripeDiagnosticsService.logError(context, error, {
      component: 'PaymentsAddPaymentComponent',
      target: this.target,
      processorConfigId: this.processorConfig?.ProcessorConfigId
    });
  }

  ngOnDestroy(): void {
    for (let subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
  isTest(): boolean {
    const environments: EnvironmentConfigItem[] = (environment as any).environments;
    if (environments) {
      const environmentKey = (environment as any).environmentKey;
      return environmentKey == 'Test' || environmentKey == 'TestLocal';
    }
    return false;
  }

}
export interface ICreatePaymentIntent {
  ClientSecret: string,
  ProcessorConfigId: number
}
export enum ModeNames {
  PurchaseCourseByStudwnt = 'purchase-course-student',
  SchoolAddPayment = 'PaymentMethod-school-add-card',// 'school-add',
  StudentAddPayment = 'PaymentMethod-student-add-card'
}
export enum AddPaymentEvents {
  AddSchoolPayment = 'PAYMENT-METHOD-ADDED-SCHOOL',
  AddStudentPayment = 'PAYMENT-METHOD-ADDED-STUDENT'
}
